import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "integrations-nav",
  "use": "integrations-nav-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"integrations-nav\"><path clip-rule=\"evenodd\" d=\"M17.25 14.125l2.76-2.76a1.25 1.25 0 000-1.767l-1.76-1.755a3.125 3.125 0 11-4.093-4.093l-1.755-1.76a1.25 1.25 0 00-1.768 0L7.875 4.75A3.125 3.125 0 104.75 7.875l-2.759 2.76a1.25 1.25 0 000 1.767l1.76 1.755a3.125 3.125 0 114.092 4.093l1.755 1.756a1.25 1.25 0 001.768 0l2.76-2.756a3.125 3.125 0 103.124-3.125z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/integrations-nav.svg
// module id = yJmH
// module chunks = 38 43